import { render } from "./App.vue?vue&type=template&id=59d1f995"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=59d1f995&lang=scss"
script.render = render

export default script